module.exports = __webpack_public_path__ + "Server-Default-Kubernetes.e1ac57c9abafd3b1cd4965a219e7405b.hashedasset.svg";